module.exports = __webpack_public_path__ + "ScheduleEvent.png";